import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type NotificationType = "success" | "error" | "info";

/** Default auto-dismiss duration when `timeoutMs` is omitted. */
export const DEFAULT_NOTIFICATION_TIMEOUT_MS = 5000;

export interface NotificationPayload {
  message: string;
  type: NotificationType;
  /**
   * Auto-dismiss after this many milliseconds.
   * Defaults to {@link DEFAULT_NOTIFICATION_TIMEOUT_MS} when omitted.
   * Set to `0` to keep visible until the user dismisses it.
   */
  timeoutMs?: number;
}

interface NotificationsState {
  current: NotificationPayload | null;
}

const initialState: NotificationsState = {
  current: null,
};

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    showNotification(state, action: PayloadAction<NotificationPayload>) {
      state.current = action.payload;
    },
    clearNotification(state) {
      state.current = null;
    },
  },
});

export const { showNotification, clearNotification } =
  notificationsSlice.actions;

export default notificationsSlice.reducer;
